import { MenuItemDef } from '@ag-grid-community/core'
import { Store } from '@ngrx/store'
import { openCommentaryDrawer } from '@helios/state-management'
import { CommentaryRowContext } from '../types/commentary-row-context'

/**
 * Returns `['separator', 'View Comments', 'Add Comment']` for a row, or `[]`
 * when the user lacks commentary access. Callers spread this into their
 * `getContextMenuItems` result — the separator is folded in so a no-access
 * user gets a clean menu with no orphan divider.
 */
export function getCommentaryContextMenuItems<T>(
  store: Store,
  hasAccessCommentary: boolean,
  commentary: CommentaryRowContext<T>,
  row: T | null | undefined,
): (string | MenuItemDef)[] {
  if (!row || !hasAccessCommentary) return []

  const ctx = commentary.build(row)
  return [
    'separator',
    {
      name: 'View Comments',
      action: () =>
        store.dispatch(
          openCommentaryDrawer({
            entityContext: ctx,
            commentaryAction: 'view',
          }),
        ),
    },
    {
      name: 'Add Comment',
      action: () =>
        store.dispatch(
          openCommentaryDrawer({ entityContext: ctx, commentaryAction: 'add' }),
        ),
    },
  ]
}
